export interface FileUpload {
  id?: number;
  name: string;
  type: string;
  size: number;
  uploadDate?: Date;
  externalUrl: string;
  displayName?: string;
}
